import { apiClient } from './client';

export interface RolePermission {
  id: number;
  module: string;
  action: string;
}

export interface RoleSummary {
  id: number;
  name: string;
  description: string | null;
  isSystem: boolean;
  createdAt: string;
  userCount: number;
  permissions: RolePermission[];
}

export type PermissionsByModule = Record<string, RolePermission[]>;

export const listRoles = async (): Promise<RoleSummary[]> => {
  const { data } = await apiClient.get('/roles');
  return data.data;
};

export const listPermissions = async (): Promise<PermissionsByModule> => {
  const { data } = await apiClient.get('/roles/permissions');
  return data.data;
};

export const createRole = async (input: { name: string; description?: string }): Promise<RoleSummary> => {
  const { data } = await apiClient.post('/roles', input);
  return data.data;
};

export const updateRole = async (
  id: number,
  input: { name?: string; description?: string },
): Promise<RoleSummary> => {
  const { data } = await apiClient.patch(`/roles/${id}`, input);
  return data.data;
};

export const deleteRole = async (id: number): Promise<void> => {
  await apiClient.delete(`/roles/${id}`);
};

export const setRolePermissions = async (id: number, permissionIds: number[]): Promise<RoleSummary> => {
  const { data } = await apiClient.put(`/roles/${id}/permissions`, { permissionIds });
  return data.data;
};
